import React, { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from "../firebase/firebaseConfig";
import ListaVideosPage from "../elements/pages/Main/ListaVideosPage";

const MisVideos = () => {
    const [misVideos, setMisVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);

    const truncateText = (text, maxLength = 200) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };

    useEffect(() => {
        onSnapshot(
            collection(db, 'inforesumenproductocalocho'),
            (snapshot) => {
                const arregloMisVideos = snapshot.docs.map((docMisVideos) => {
                    return { ...docMisVideos.data(), id: docMisVideos.id };
                });

                setMisVideos(arregloMisVideos);
                setLoading(false); // Even if there's an error, stop loading
            },
            (error) => {
                console.log(error);
            }
        );
    }, []);

    // Carrusel: Actualizar el índice cada 10 segundos
    useEffect(() => {
        if (misVideos.length > 1) {
            const interval = setInterval(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % misVideos.length);
            }, 10000); // 10000ms = 10s
            return () => clearInterval(interval);
        }
    }, [misVideos.length]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress sx={{ color: '#5d0303' }} />
            </Box>
            );
        }

        if (misVideos.length === 0) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Typography variant="h6">No hay datos por mostrar</Typography>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                backgroundColor: '#0a1f44',
                color: '#fff',
                backgroundImage: 'linear-gradient(180deg, #5d0303, #8E0505)',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row-reverse' },
                justifyContent: 'center',
                width: '100%',
                padding: { xs: '2%', sm: '4%', md: '5%' },
                gap: { xs: 2, sm: 4 },
            }}
        >
            <ListaVideosPage />

            <Box
                key={misVideos[currentIndex].id}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: { xs: '90%', sm: '60%', md: '50%' },
                    height: 'auto',
                    padding: { xs: '5%', sm: '2%' },
                    margin: { xs: '5% auto', sm: '0 auto' },
                    alignItems: 'center',
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                        margin: { xs: '12px 0', sm: '18px 0' },
                        textAlign: 'center',
                    }}
                >
                    {misVideos[currentIndex].titulo}
                </Typography>

                <Typography
                    variant="h5"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.2rem' },
                        margin: { xs: '10px 0', sm: '15px 0' },
                        textAlign: 'center',
                    }}
                >
                    {misVideos[currentIndex].subtitulo}
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        margin: { xs: '8px 0', sm: '12px 0' },
                        textAlign: 'center',
                    }}
                >
                    {truncateText(misVideos[currentIndex].descripcion)}
                </Typography>

                <Button
                    size="small"
                    variant="outlined"
                    sx={{
                        width: { xs: '80%', sm: '60%', md: '50%' },
                        alignSelf: 'center',
                        color: '#f9f9f9',
                        background: '#8E0505',
                        borderColor: '#f9f9f9',
                        mt: 2,
                        ':hover': {
                            backgroundColor: '#ff6f61',
                            borderColor: '#f9f9f9',
                        },
                    }}
                >
                    Ver más
                </Button>
            </Box>
        </Box>
    );
};

export default MisVideos;
